/** MI DOMINO — 📱 play in landscape. A phone held upright gets a full-screen
 *  "turn your phone" card. We ask the browser to lock landscape (Android
 *  installed app); if the phone still stays upright after a few seconds (rotation
 *  lock on, or iPhone Safari which can't lock), the card switches to the
 *  "unlock rotation" text. Desktops and tablets are never covered. */
import { LANG } from './i18n';

const TXT: Record<'turn' | 'unlock', { es: [string, string]; en: [string, string] }> = {
  turn: {
    es: ['GIRA TU TELÉFONO', 'MI DOMINÓ se juega en horizontal.<br>Ponlo de lado para empezar la mesa.'],
    en: ['TURN YOUR PHONE', 'MI DOMINÓ is played in landscape.<br>Turn it sideways to start the table.'],
  },
  unlock: {
    es: ['DESBLOQUEA LA ROTACIÓN', 'Tu teléfono tiene la rotación bloqueada.<br>Desbloquéala desde el Centro de control y gira el teléfono a horizontal.'],
    en: ['UNLOCK ROTATION', 'Your phone has rotation locked.<br>Unlock it from Control Center and turn the phone sideways.'],
  },
};

const UNLOCK_AFTER_MS = 4000;
let stuckTimer: ReturnType<typeof setTimeout> | null = null;
let unlockMode = false;

const upright = (): boolean => window.matchMedia('(max-width: 900px) and (orientation: portrait)').matches;

function render(): void {
  const el = document.getElementById('rotate-lock');
  if (!el) return;
  const k = unlockMode ? 'unlock' : 'turn';
  const [h, p] = TXT[k][LANG === 'en' ? 'en' : 'es'];
  const h2 = el.querySelector('h2'), p1 = el.querySelector('p');
  if (h2) h2.textContent = h;
  if (p1) p1.innerHTML = p;
  el.classList.toggle('on', upright());
}

async function tryLock(): Promise<void> {
  const so: any = (screen as any).orientation;
  if (!so || typeof so.lock !== 'function') return;
  try { await so.lock('landscape'); } catch { /* browser refuses outside an installed app / fullscreen */ }
}

function onChange(): void {
  if (upright()) {
    if (!stuckTimer) stuckTimer = setTimeout(() => { unlockMode = true; render(); }, UNLOCK_AFTER_MS);
  } else {
    if (stuckTimer) clearTimeout(stuckTimer);
    stuckTimer = null;
    unlockMode = false;
  }
  render();
}

export function initOrientation(): void {
  if (!document.getElementById('rotate-lock')) return;
  window.addEventListener('resize', onChange);
  window.addEventListener('orientationchange', onChange);
  const so: any = (screen as any).orientation;
  if (so && so.addEventListener) so.addEventListener('change', onChange);
  document.addEventListener('pointerdown', () => { tryLock(); onChange(); }, { once: true });
  tryLock();
  onChange();
}
